import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "leading-7 text-sm font-medium text-gray-500" }
const _hoisted_2 = { class: "p-3 rounded-md border-2 border-gray-200" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm font-medium text-gray-500"
}
const _hoisted_4 = { class: "w-2/5 px-2" }
const _hoisted_5 = { class: "w-2/5 px-2" }
const _hoisted_6 = { class: "w-1/5 px-1 mt-7" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, "削除", -1)
const _hoisted_8 = {
  key: 1,
  class: "flex justify-center mt-4"
}
const _hoisted_9 = {
  key: 0,
  for: "any",
  class: "flex items-center rounded-md font-medium text-sm transition-all duration-300 px-4 py-2 cursor-pointer text-primary-500 hover:text-primary-500 hover:bg-gray-100"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" ファイルをアップロードして追加 ")
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, "直接 URL を入力して追加", -1)
const _hoisted_12 = {
  key: 2,
  class: "mt-4 pt-4 border-t-2 border-dashed border-gray-200"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "text-sm font-medium text-gray-500" }, "プレビュー", -1)
const _hoisted_14 = { class: "mt-2 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")

  return (_openBlock(), _createBlock("div", {
    class: this.class
  }, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.term), 1),
    _createVNode("div", _hoisted_2, [
      (_ctx.editingLinks.length === 0)
        ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.term) + "はありません ", 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.editingLinks, (link, i) => {
        return (_openBlock(), _createBlock("div", {
          key: `link${i}`,
          class: "flex items-start my-1"
        }, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_m_text_field, {
              label: "表示",
              name: `linkLabel${i}`,
              type: "text",
              placeholder: "",
              value: link.label,
              entered: link.labelEntered,
              invalid: !link.label,
              "invalid-message": "入力してください",
              onInput: ($event: any) => (_ctx.update($event, 'label', i)),
              onEnter: ($event: any) => (link.labelEntered = true)
            }, null, 8, ["name", "value", "entered", "invalid", "onInput", "onEnter"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_m_text_field, {
              label: "リンク先 URL",
              name: `linkURL${i}`,
              type: "text",
              placeholder: "",
              value: link.isExternal ? link.url : '編集できません',
              entered: link.urlEntered,
              invalid: !link.url,
              "invalid-message": "入力してください",
              disabled: !link.isExternal,
              onInput: ($event: any) => (_ctx.update($event, 'url', i)),
              onEnter: ($event: any) => (link.urlEntered = true)
            }, null, 8, ["name", "value", "entered", "invalid", "disabled", "onInput", "onEnter"])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_m_button, {
              color: "gray-500",
              text: "",
              onClick: ($event: any) => (_ctx.deleteRelatedLink(i))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_m_icon, {
                  type: "trash",
                  class: "mr-2"
                }),
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]))
      }), 128)),
      (_ctx.limit < 0 || _ctx.editingLinks.length < _ctx.limit)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            (!_ctx.isDirectUrlEditorOnly)
              ? (_openBlock(), _createBlock("label", _hoisted_9, [
                  _createVNode(_component_m_icon, {
                    type: "plus",
                    class: "mr-2"
                  }),
                  _hoisted_10,
                  _createVNode("input", {
                    id: "any",
                    type: "file",
                    accept: "*",
                    name: "any",
                    class: "hidden",
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.freeFormatFileUpload && _ctx.freeFormatFileUpload(...args)))
                  }, null, 32)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_m_button, {
              text: "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addRelatedLink()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_m_icon, {
                  type: "plus",
                  class: "mr-2"
                }),
                _hoisted_11
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.editingLinks.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _hoisted_13,
            _createVNode("div", _hoisted_14, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.editingLinks, (link, i) => {
                return (_openBlock(), _createBlock("a", {
                  key: `link${i}`,
                  href: link.url,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "underline text-blue-500 mr-4 break-all"
                }, _toDisplayString(link.label), 9, ["href"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}